import {CLEAR_TOP_BAR_NAVIGATION, SET_TOP_BAR_NAVIGATION} from "../../actions/menu/topBarAction";

const initialState = {
    navigationInfo: undefined
};

export default function topBarReducer(state = initialState, action) {
    switch (action.type) {

        case CLEAR_TOP_BAR_NAVIGATION: {
            return {
                ...state,
                navigationInfo: undefined
            };
        }

        case SET_TOP_BAR_NAVIGATION: {
            return {
                ...state,
                navigationInfo: {
                    display: action.info.display,
                    url: action.info.routeUrl
                }
            };
        }

        default:
            return state;

    }
}
